import { useTranslation } from "react-i18next";
import type { Valuation } from "../../lib/realestate";
import { TimeSeriesLineChart } from "../charts/TimeSeriesLineChart";

interface Props {
  valuations: Valuation[];
}

export function ValuationHistoryChart({ valuations }: Props) {
  const { t } = useTranslation();
  const data = [...valuations]
    .sort((a, b) => new Date(a.stichtag).getTime() - new Date(b.stichtag).getTime())
    .map((v) => ({ date: v.stichtag, valueCents: v.valueCents }));

  if (data.length === 0) {
    return <p className="text-sm text-slate-500">{t("realestate.valuation.no_data")}</p>;
  }

  return <TimeSeriesLineChart data={data} />;
}
